import axios from "axios";
import { triggerSessionAlert } from "../utils/SessionAlertHelper";

// Base URL for your API
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const addProduct = async (productData) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/products/add`,
      productData,
      {
        withCredentials: true,
      }
    );

    if (response.status === 207) {
      response.data.data.product.brand = response.data.data.brand;
    }

    return {
      status: response.status,
      success: response.data.success,
      message: response.data.message || "Product added successfully",
      data: response.data.data,
      error: response.data?.error || null,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      status: error.response?.status || 500,
      success: error.response?.data?.success || false,
      message:
        error.response?.data?.message ||
        "An error occurred while adding product.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const editProduct = async (productData) => {
  try {
    // console.log("Product Data:", productData);
    // Check if productData is an object and has the required properties
    const response = await axios.put(
      `${API_BASE_URL}/products/update`,
      productData,
      {
        withCredentials: true,
      }
    );

    return {
      status: response.status,
      success: response.data.success,
      message: response.data.message || "Product updated successfully",
      data: response.data.data,
      error: response.data?.error || null,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      status: error.response?.status || 500,
      success: error.response?.data?.success || false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating product.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

 
export const getAllCategories = async () => {
  try {

    const response = await axios.get(
      `${API_BASE_URL}/products/categories`,
      {
        withCredentials: true,
      }
    );
    return {
      success: response.data.success,
      message: response.data.message || "Categories retrieved successfully",
      data: response.data.data
    };
  } catch (error) {
    if (!error.response) {
      window.location.href = "/server-down";
      return { success: false, message: "Cannot connect to the server." };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message: error.response?.data?.message || "Failed to fetch categories."
    };
  }
};

export const getAllProducts = async (pagination, brand, search, category) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/products/pricing?page=${pagination.page}&limit=${pagination.limit}&brand=${brand}&search=${search}&category=${category || ""}`,
      { withCredentials: true }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Products retrieved successfully",
      data: response.data.data // ✅ return whole data object
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: error.response?.data?.success || false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching products.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const deleteProduct = async (productId) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/products/delete/${productId}`,
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Product deleted successfully",
      data: response.data.data,
      error: response.data?.error || "Unexpected error occurred",
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while deleting product.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const updateProductStatus = async (productId, status) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/products/update/status`,
      {
        productId,
        status,
      },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Product status updated successfully",
      data: response.data.data.product,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating product status.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const updateProductBatchStatus = async (batchId, status) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/products/update/batch/status`,
      {
        batchId: batchId,
        status: status,
      },
      {
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Batch status updated successfully",
      data: response.data.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating batch status.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const getProductById = async (id) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/products/get/${id}`, {
      withCredentials: true,
    });

    return {
      success: response.data.success,
      message: response.data.message || "Product retrieved successfully",
      data: response.data.data.product,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching product.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const importCodes = async (productId, batchName, SelectedFile) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/products/import/codes`,
      {
        productId: productId,
        batchName: batchName,
        codes: SelectedFile,
      },
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Codes imported successfully",
      data: response.data.data,
      totalCodes: response.data.data.totalCodes,
      duplicateCodes: response.data.data.duplicateCodes,
      emptyLines: response.data.data.emptyLines,
      invalidLines: response.data.data.invalidLines,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while importing codes.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const exportCodes = async (batchId) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/products/export/codes`,
      { batchId: batchId },
      {
        withCredentials: true,
      }
    );

    return {
      success: true,
      message: response.data.message || "Codes exported successfully",
      data: response.data,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while exporting codes.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const getDownloadHistory = async (productID) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/products/download/history?productId=${productID}`,
      { withCredentials: true }
    );

    return {
      success: response.data.success,
      message: response.data.message || "Batch status updated successfully",
      data: response.data.data.downloadHistory,
    };
  } catch (error) {
    // Network errors (server unreachable)
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable.",
        },
      };
    }
   if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while fetching download history.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later",
      },
    };
  }
};

export const updateSellingPrice = async (productId, sellingPrice) => {
  try {
    const response = await axios.patch(
      `${API_BASE_URL}/products/selling-price/${productId}`,
      { sellingPrice },
      { withCredentials: true }
    );

    return {
      success: response.data.success,
      message:
        response.data.message || "Product selling price updated successfully",
      data: response.data.data
    };
  } catch (error) {
    if (!error.response) {
      window.location.href = "/server-down";
      return {
        success: false,
        message:
          "Cannot connect to the server. Please check your network or try again later.",
        error: {
          code: "NETWORK_ERROR",
          message: error.message || "Network Error",
          solution: "Ensure the backend server is running and reachable."
        }
      };
    }
    if (error.response?.status === 401) {
      triggerSessionAlert("Your session has expired. Please sign in again.");
      return;
    }
    if (error.response?.status === 403) {
      triggerSessionAlert("Sorry, you do not have permission.");
      return;
    }
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return;
    }
    return {
      success: false,
      message:
        error.response?.data?.message ||
        "An error occurred while updating selling price.",
      error: error.response?.data?.error || {
        code: error.response?.status || 500,
        message: error.message || "Internal Server Error",
        solution: "Please try again later"
      }
    };
  }
};

export const getAllProductIds = async (pagination = { page: 1, limit: 10 }) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/products?shorten=true&page=${pagination.page}&limit=${pagination.limit}`,
      { withCredentials: true }
    );

    return {
      products: response.data.data.product,
      totalPages: response.data.data.totalPages,
    };
  } catch (error) {
    if (error.response?.status >= 500) {
      window.location.href = "/server-down";
      return { products: [], totalPages: 1 };
    }
    console.error("Error fetching product IDs:", error);
    return { products: [], totalPages: 1 };
  }
};
